<style lang="postcss">
	div.header {
		margin: 1.25rem 0 2rem 0;
	}
	div.header p {
		margin: 1rem 0;
		text-wrap: balance;
	}
	.form-templates-h1 {
		font-size: 2.25rem;
		padding: 0 0;
		font-weight: 600;
		line-height: 1;
		letter-spacing: -0.5px;
		line-height: 1.3;
		color: rgb(46, 57, 72);
		position: relative;
		text-align: left;
		margin-bottom: 0rem;
		margin-top: 0rem;
		text-wrap: balance;
	}
	@media (max-width: 768px) {
		div.header {
			margin: 0;
		}
		.form-templates-h1 {
			font-size: 1.75rem;
			line-height: 1.3;
		}
	}
</style>

<script lang="ts">
	export let data;
	import { PUBLIC_SITE_URL } from "$env/static/public";
	import { title, titleCount } from "$lib/helpers/functions";
	import TemplateTile from "$src/lib/Components/Templates/TemplateTile.svelte";

	let templates: any[] = [];
	$: templates = data.templates ?? [];
	$: count = data.template_counts.subcategories[data.subcategory.value] ?? 0;
	$: pageTitle =
		titleCount(count) +
		(data.subcategory.seo_title ?? title(data.subcategory.longLabel));
</script>

<svelte:head>
	<title>{pageTitle}</title>
	<link
		rel="canonical"
		href="{PUBLIC_SITE_URL}/form-templates/{data.subcategory.value}" />
	<meta name="description" content="{data.subcategory.seo_description}" />
</svelte:head>

<div class="header">
	<h1 class="form-templates-h1">
		{data.subcategory.longLabel}
	</h1>
	<p>
		{data.subcategory.display_description}
	</p>
</div>

<div class="@container">
	<div class="mt-4 grid grid-cols-2 gap-3 @md:grid-cols-3 @lg:grid-cols-4">
		{#each templates as template, tem_i}
			<TemplateTile eager="{tem_i <= 3}" data="{template}" />
		{:else}
			<p
				class="mx-auto w-full col-span-full text-left mt-12 text-lg text-gray-500">
				No templates found
			</p>
		{/each}
	</div>
</div>
